import '@babel/polyfill'
import objectFitImages from 'object-fit-images';
import { Provider } from 'react-redux'
import DefaultApp from 'components/app/default-app'
import api from 'libs/api'
import perf from 'libs/perf'
import { DateTime, Settings } from 'luxon'
import 'raf/polyfill'
import 'whatwg-fetch'
import store from './store'
import './index.css'

objectFitImages()

perf.measureNow('browser:ready', 'browser finished loading application resources')

if (!DateTime.local().locale.startsWith('en')) {
  Settings.defaultLocale = 'en'
}

// eslint-disable-next-line react/display-name
export default () => (
  <Provider store={store}>
    {api.ready() ? (
      <DefaultApp />
    ) : (
      <div style={{ padding: '40px 20px', textAlign: 'center' }}>
        Error: application not properly set up!
      </div>
    )}
  </Provider>
)
